import * as React from "react"
import {TableCell} from "@mui/material";

import {LabelCountry} from "@components";
import { useBuildExternalURL } from "@hooks"


export default function PricingRetailerCell({ country, retailer, siteID, productID, skuID }) {
    const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })
    return <TableCell sx={{ textWrap: 'nowrap' }}>
        <LabelCountry
            country={country}
            label={retailer}
            url={productURL}
        />
    </TableCell>
}